<li
  class="list-group-item"
  [class.active]="isActive()"
  *ngIf="displayIf"
  (click)="handleClick()"
>
  <a>
    <div class="harp-sidebar-icon-container">
      <img
        *ngIf="iconHostedLocally"
        [src]="getIconSrcName(iconIdentifier, active)"
        class="icon"
        [class.active]="active"
      />
      <span *ngIf="!iconHostedLocally" [class]="iconIdentifier"></span>
    </div>
    {{ itemTitle }}
  </a>
</li>
